import React from 'react';
import { getTierById } from '../../constants/tierConfig';
import './AvatarRing.css';

const SIZE_MAP = {
  sm: { dimension: 44, fontSize: 13 },
  md: { dimension: 48, fontSize: 13 },
  lg: { dimension: 80, fontSize: 18 },
  xl: { dimension: 120, fontSize: 22 },
  user: { dimension: 140, fontSize: 24 },
  tier: { dimension: 90, fontSize: 16 },
};

const AvatarRing = ({
  src,
  alt = '',
  tierId = 'FIRST_PAGE',
  track = 'READER',
  size = 'md',
  className = '',
  onClick,
  lazy = false,
}) => {
  const tier = getTierById(tierId, track);
  const dims = SIZE_MAP[size] || SIZE_MAP.md;
  const { dimension, fontSize } = dims;

  return (
    <div
      className={`ring-base ring-base--${size} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      style={{ width: dimension, height: dimension, '--ring-color': tier.color }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          width={dimension}
          height={dimension}
          loading={lazy ? 'lazy' : undefined}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <div
        className="ring-base__fallback"
        style={{ display: src ? 'none' : 'flex', fontSize: `${fontSize}px` }}
      >
        {alt?.charAt(0)?.toUpperCase() || '?'}
      </div>
    </div>
  );
};

export default AvatarRing;
